import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { invitesApi } from '../lib/api'
import type { IssueInviteRequest } from '../types/invites'

const KEY = ['admin', 'invites']

export function useInvites() {
  return useQuery({
    queryKey: KEY,
    queryFn: async () => (await invitesApi.getAll()).data,
  })
}

export function useIssueInvite() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (data: IssueInviteRequest) => (await invitesApi.issue(data)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  })
}

export function useResendInvite() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (id: string) => (await invitesApi.resend(id)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  })
}

export function useRevokeInvite() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => invitesApi.revoke(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  })
}
